export const GLOBAL_SETTINGS_PERMISSION_ITEMS = Object.freeze([
  Object.freeze({
    key: "hotel_settings.view_users_tab",
    label: "Access Users & Roles",
  }),
  Object.freeze({
    key: "hotel_settings.manage_users",
    label: "Create / Activate / Deactivate / Delete users",
  }),
]);

export const REVENUE_MANAGEMENT_SELECT_ALL_PERMISSION_KEYS = Object.freeze([
  "revenue.view_market_prices",
  "revenue.apply_market_prices",
  "revenue.view_all_prices",
  "revenue.view_price_detail",
  "revenue.create_price",
  "revenue.delete_price",
  "revenue.view_room_rates",
  "revenue.create_room_rate",
  "revenue_optimizer.access",
  "revenue.manage_stop_sells",
  "revenue.allow_rms",
  "revenue.allow_scraper",
]);

export const RMS_ROLE_PERMISSION_ITEMS = Object.freeze([
  Object.freeze({ key: "rms.view", label: "View RMS outputs" }),
  Object.freeze({ key: "rms.configure", label: "Configure RMS" }),
  Object.freeze({ key: "rms.approve", label: "Approve RMS recommendations" }),
  Object.freeze({ key: "rms.apply", label: "Apply RMS recommendations" }),
  Object.freeze({ key: "rms.rollback", label: "Rollback RMS applications" }),
]);

export const RMS_ROLE_PERMISSION_KEYS = Object.freeze(
  RMS_ROLE_PERMISSION_ITEMS.map(({ key }) => key)
);
